import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CONFIG } from '../../constants/constants';
import { ConfigurationControlService } from '../configuration/configurationControl.service';
import { catchError, timeout } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EstadoUsuarioService {

  //constructor de la clase
  constructor(private http: HttpClient,
    private _configurationControlService: ConfigurationControlService,) {
    this.http = http;
  }

  public getEstadoUsuario(user: string, token: string): Promise<any> {
    let _headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': token,
      'user': user,
    });

    const timeoutDuration = this._configurationControlService.timeoutService; // Establecer el tiempo de espera en milisegundos
    return this.http.get<Boolean>(CONFIG.REST_END_POINT + '/estado/usuario', { headers: _headers })
          .pipe(
            timeout(timeoutDuration),
            catchError(error => {
              if (error.name === 'TimeoutError') {
                // Manejar el error de tiempo de espera
                console.log('La solicitud excedió el tiempo de espera.');
              }
              return throwError(error);
            })
          ).toPromise();

  }
}
